import { GetLayout } from "components/get-layout";

export function CampanhaURAWhatsapp() {
  return (
    <GetLayout>
      <></>
    </GetLayout>
  );
}
